import axios from './axiosWrapper';

function unwrapFalconPayload(res) {
    const body = res?.data;
    if (body && typeof body === 'object' && 'data' in body) {
        return body.data;
    }
    return body;
}

function withUnwrappedData(promise) {
    return promise.then((res) => ({
        ...res,
        data: unwrapFalconPayload(res),
    }));
}

const CrapExcel = {
    presignUpload(fileName, fileSize) {
        return withUnwrappedData(
            axios.post('crap/excel-store/presign-upload', { fileName, fileSize })
        );
    },
    listObjects({ maxKeys = 50, continuationToken } = {}) {
        const params = new URLSearchParams();
        params.set('maxKeys', String(maxKeys));
        if (continuationToken) {
            params.set('continuationToken', continuationToken);
        }
        return withUnwrappedData(axios.get(`crap/excel-store/objects?${params.toString()}`));
    },
    presignDownload(key) {
        const params = new URLSearchParams();
        params.set('key', key);
        return withUnwrappedData(axios.get(`crap/excel-store/presign-download?${params.toString()}`));
    },
    deleteObject(key) {
        const params = new URLSearchParams();
        params.set('key', key);
        return withUnwrappedData(axios.delete(`crap/excel-store/object?${params.toString()}`));
    },
    /**
     * Admin: all form submissions (sharded monitoring query).
     */
    listAllFormSubmissions({ limit = 25, lastKey = null } = {}) {
        const params = new URLSearchParams();
        params.set('limit', String(limit));
        if (lastKey) {
            params.set('lastKey', encodeURIComponent(JSON.stringify(lastKey)));
        }
        return withUnwrappedData(axios.get(`crap/all-form-submissions?${params.toString()}`));
    },
    /**
     * Admin: all generated reports (sharded monitoring query).
     */
    listAllGeneratedReports({ limit = 25, lastKey = null } = {}) {
        const params = new URLSearchParams();
        params.set('limit', String(limit));
        if (lastKey) {
            params.set('lastKey', encodeURIComponent(JSON.stringify(lastKey)));
        }
        return withUnwrappedData(axios.get(`crap/all-generated-reports?${params.toString()}`));
    },
    regenerateReport(formID) {
        const safeFormID = encodeURIComponent(String(formID || ''));
        return withUnwrappedData(axios.post(`crap/admin/regenerate-report/${safeFormID}`));
    },
    getReportByID(formID, reportID) {
        const safeFormID = encodeURIComponent(String(formID || ''));
        const safeReportID = encodeURIComponent(String(reportID || ''));
        return withUnwrappedData(axios.get(`crap/get-report-by-id/${safeFormID}/report/${safeReportID}`));
    },
};

export default CrapExcel;
